import React from 'react'
import { View } from 'react-native'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { FullRegistrationData, Moment, Step3Data } from '@hooks'
import { Button, MomentsList, OnBoarding } from '@components'
import { useTheme } from '@react-navigation/native'
import { useLanguage } from '@context'
import { Step3ValidationSchema } from './schema'
import getStyle from './style'
import { StepTitle } from '../components'

export const Step3Form = ({
  onSubmit,
}: {
  onSubmit: (newData: Partial<FullRegistrationData>) => void
}) => {
  const { t } = useLanguage()

  const theme = useTheme()
  const styles = getStyle(theme)

  const { control, handleSubmit, clearErrors, watch, setValue } = useForm<Step3Data>({
    defaultValues: {
      moments: [],
    },
    resolver: yupResolver(Step3ValidationSchema),
  })

  const momentsValue = watch('moments')

  const handleTogglePreference = (moment: Moment) => {
    const newMoments = momentsValue.find(p => p.id === moment.id)
      ? momentsValue.filter(p => p.id !== moment.id)
      : [...momentsValue, moment]

    setValue('moments', newMoments)
    clearErrors('moments')
  }

  return (
    <View style={styles.container}>
      <OnBoarding>
        <StepTitle
          mainTitle={t('registerStep3.mainTitle')}
          subtitle={t('registerStep3.title')}
        />
        <MomentsList<Step3Data>
          control={control}
          name="moments"
          moments={momentsValue}
          onToggle={handleTogglePreference}
        />
        <Button
          title={t('registerStepHastags.next')}
          onPress={handleSubmit(onSubmit)}
          containerStyle={styles.button}
        />
      </OnBoarding>
    </View>
  )
} 